import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-buttons/js/dataTables.buttons.min.js";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import { Button, Modal, Form, Col, Row } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import { API_URL_LOCAL } from "..";
import { Icon } from "@iconify/react/dist/iconify.js";

const EmployeesPage = (props) => {
  const tableRef = useRef(null);
  const history = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showSeparationModal, setShowSeparationModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [separationData, setSeparationData] = useState({
    type: null,
    reason: null,
    reasonComments: "",
    date: "",
    comments: "",
    clearanceDate: "",
  });

  // Separation Type and Reason Options for react-select
  const separationTypes = [
    { value: "resignation", label: "Resignation" },
    { value: "termination", label: "Termination" },
    { value: "retirement", label: "Retirement" },
    { value: "layoff", label: "Layoff" },
  ];

  const separationReasons = [
    { value: "personal", label: "Personal Reasons" },
    { value: "performance", label: "Performance Issues" },
    { value: "relocation", label: "Relocation" },
    { value: "career_change", label: "Career Change" },
    { value: "other", label: "Other" },
  ];

  // Fetch employees
  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user || !user.id) throw new Error("User not found in localStorage");

        // Fetch employees
        const response = await axios.get(`${API_URL_LOCAL}/api/employee/fetch/${user.id}`);
        setEmployees(response.data.employees || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Initialize DataTable
  useEffect(() => {
    if (!employees.length || !tableRef.current) return;

    const table = $(tableRef.current).DataTable({
      data: employees,
      columns: [
        {
          title: "Image",
          data: "profile_image",
          render: (data) =>
            data ? `<img src="${data}" alt="Employee" style="width: 40px; height: 40px; border-radius: 50%;" />` : "-",
        },
        { title: "ID", data: "id" },
        { title: "Full Name", data: "first_name" },
        { title: "Designation", data: "job.job_title" },
        {
          title: "Department",
          data: "job.department",
          render: (data) => data?.name || "N/A",
        },
        {
          title: "Supervisor Name",
          data: "supervisor",
          render: (data) =>  data ?  data?.first_name + ' ' + data?.last_name : "N/A",
        },
        { title: "Status", data: "status" },
        {
          title: "Hiring Date",
          data: "job.joing_date",
          render: (data) => (data ? new Date(data).toLocaleDateString() : "N/A"),
        },
        {
          title: "Actions",
          data: null,
          render: (data, type, row) => `
          <div class="dropdown">
          <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="ph ph-list"></i>
          </button>
          <ul class="dropdown-menu">
            
            <li>
            <a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}">
            <i class="ph ph-eye"></i> View Employee</a></li>
            <li><a style="cursor:pointer" class="dropdown-item separation-btn" data-id="${row.id}"><i class="ph ph-pencil"></i>Mark separtion</a></li>
        
          </ul>
        </div>
          
          `,
          orderable: false,
        },
      ],
      responsive: true,
      dom: "Bfrtip",
      buttons: ["copy", "csv", "excel", "pdf", "print"],
      destroy: true,
    });

    // Handle Separation button click
    $(tableRef.current).on("click", ".view-btn", function () {
      const id = $(this).data("id");
      history(`/staff/view/${id}`)
    });
    $(tableRef.current).on("click", ".separation-btn", function () {
      const id = $(this).data("id");
      setSelectedEmployee(employees.find((emp) => emp.id === id));
      setShowSeparationModal(true);
    });

    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [employees]);

  // Handle Separation Form Changes
  const handleSeparationChange = (e) => {
    const { name, value } = e.target;
    setSeparationData({ ...separationData, [name]: value });
  };

  const handleSelectChange = (name, selected) => {
    setSeparationData({ ...separationData, [name]: selected });
  };

  // Handle Save Separation
  const handleSaveSeparation = async () => {
    try {
      if (
        !separationData.type ||
        !separationData.reason ||
        !separationData.date ||
        !separationData.clearanceDate
      ) {
        alert("Please fill all required fields");
        return;
      }

      const payload = {
        employee_id: selectedEmployee.id,
        separation_type: separationData.type.value,
        reason: separationData.reason.value,
        reason_comments: separationData.reasonComments,
        separation_date: separationData.date,
        comments: separationData.comments,
        clearance_date: separationData.clearanceDate,
      };

      const response = await axios.post(`${API_URL_LOCAL}/api/employee/separation`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 201) {
        setEmployees(
          employees.map((emp) =>
            emp.id === selectedEmployee.id ? { ...emp, status: "Separated" } : emp
          )
        );
        setShowSeparationModal(false);
        setSeparationData({
          type: null,
          reason: null,
          reasonComments: "",
          date: "",
          comments: "",
          clearanceDate: "",
        });
      }
    } catch (err) {
      alert("Failed to save separation: " + err.message);
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Employees" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          {loading && <div className="text-center">Loading...</div>}
          {error && (
            <div className="alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-20 fw-semibold text-lg radius-8">
              {error}
            </div>
          )}
          {!loading && !error && (
            <div className="table-responsive">
              <table
                ref={tableRef}
                className="table table-striped"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>ID</th>
                    <th>Full Name</th>
                    <th>Designation</th>
                    <th>Department</th>
                    <th>Supervisor Name</th>
                    <th>Status</th>
                    <th>Hiring Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Separation Modal */}
      <Modal
      {...props}
      size="lg"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showSeparationModal} style={{zIndex: 9000}} onHide={() => setShowSeparationModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>Mark Separation</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
           <Col md="6">
           <Form.Group className="mb-20">
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                Separation Type <span className="text-danger-600">*</span>
              </Form.Label>
              <Select
                options={separationTypes}
                value={separationData.type}
                onChange={(selected) => handleSelectChange("type", selected)}
                placeholder="Select Separation Type"
              />
            </Form.Group>
           </Col>
           <Col md="6">
           <Form.Group className="mb-20">
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                Reason <span className="text-danger-600">*</span>
              </Form.Label>
              <Select
                options={separationReasons}
                value={separationData.reason}
                onChange={(selected) => handleSelectChange("reason", selected)}
                placeholder="Select Reason"
              />
            </Form.Group>
           </Col>
           </Row>
            
            <Form.Group className="mb-20">
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                Reason Comments
              </Form.Label>
              <Form.Control
                as="textarea"
                name="reasonComments"
                value={separationData.reasonComments}
                onChange={handleSeparationChange}
                placeholder="Enter reason comments"
                className="radius-8"
                rows={3}
              />
            </Form.Group>
            <Row>
           <Col md="6">
            <Form.Group className="mb-20">
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                Separation Date <span className="text-danger-600">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={separationData.date}
                onChange={handleSeparationChange}
                className="radius-8"
              />
            </Form.Group>
            </Col>
           <Col md="6">
           <Form.Group className="mb-20">
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                Clearance Date <span className="text-danger-600">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                name="clearanceDate"
                value={separationData.clearanceDate}
                onChange={handleSeparationChange}
                className="radius-8"
              />
            </Form.Group>
            </Col>
            </Row>
            <Form.Group className="mb-20">
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                Comments
              </Form.Label>
              <Form.Control
                as="textarea"
                name="comments"
                value={separationData.comments}
                onChange={handleSeparationChange}
                placeholder="Enter comments"
                className="radius-8"
                rows={3}
              />
            </Form.Group>
           
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="text-md px-24 py-8 radius-8"
            onClick={() => setShowSeparationModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="text-md px-24 py-8 radius-8"
            onClick={handleSaveSeparation}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </MasterLayout>
  );
};

export default EmployeesPage;